module.exports = __webpack_public_path__ + "static/media/ico-fc-fraude-id.9027a985.png";